// taken from recompose:
// https://github.com/acdlite/recompose/blob/master/src/packages/recompose/toClass.js

// I didn't want to include recompose,
// because I only need this as a workaround
// for a bug in semantic-ui-react:
// <Button as={NavLink}/> leads to
// Warning: Function components cannot be given refs. Attempts to access this ref will fail.
// See:
// https://github.com/Semantic-Org/Semantic-UI-React/issues/2295#issuecomment-342584880
import React, { Component } from 'react'

const isClassComponent = Component =>
  Boolean(
    Component &&
      Component.prototype &&
      typeof Component.prototype.render === 'function'
  )

const getDisplayName = Component => {
  if (typeof Component === 'string') {
    return Component
  }
  if (!Component) {
    return undefined
  }
  return Component.displayName || Component.name || 'Component'
}

const toClass = baseComponent =>
  isClassComponent(baseComponent)
    ? baseComponent
    : class ToClass extends Component {
        static displayName = getDisplayName(baseComponent)
        static propTypes = baseComponent.propTypes // eslint-disable-line
        static contextTypes = baseComponent.contextTypes
        static defaultProps = baseComponent.defaultProps
        render() {
          if (typeof baseComponent === 'string') {
            return React.createElement(baseComponent, this.props)
          }
          return baseComponent(this.props, this.context)
        }
      }
export default toClass